var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g, _path50, _g2, _path51, _g3, _path52, _g4, _path53, _g5, _path54, _g6, _path55, _g7, _path56, _g8, _path57, _g9, _path58, _g10, _path59, _g11, _path60, _g12, _path61, _g13, _path62, _g14, _path63, _g15, _path64, _g16, _path65, _g17, _path66, _g18, _path67, _g19, _path68, _g20, _path69, _g21, _path70, _g22, _path71, _g23, _path72, _g24, _path73, _g25, _path74, _g26, _path75, _g27, _path76, _g28, _path77, _g29, _path78, _g30, _path79, _g31, _path80, _g32, _path81, _g33, _path82, _g34, _path83, _g35, _path84, _g36, _path85, _g37, _path86, _g38, _path87, _g39, _path88, _g40, _path89, _g41, _path90, _g42, _path91, _g43, _path92, _g44, _path93, _g45, _path94, _g46, _path95, _g47, _path96, _g48, _path97, _g49, _path98, _g50, _path99, _g51, _path100, _g52, _path101, _g53, _path102, _g54, _path103, _g55, _path104, _g56, _path105, _g57, _path106, _g58, _path107, _g59, _path108, _g60, _path109, _g61, _path110, _g62, _path111, _g63, _path112, _g64, _path113, _g65, _path114, _g66, _path115, _g67, _path116, _g68, _path117, _g69, _path118, _g70, _path119, _g71, _path120, _g72, _path121, _g73, _path122, _g74, _path123, _g75, _path124, _g76, _path125, _g77, _path126, _g78, _path127, _g79, _path128, _g80, _path129, _g81, _path130, _g82, _path131, _g83, _path132, _g84, _path133, _g85, _path134, _g86, _path135, _g87, _path136, _g88, _path137, _g89, _path138, _g90, _path139, _g91, _path140, _g92, _path141, _g93, _path142, _g94, _path143, _g95, _path144, _g96, _path145, _g97, _path146, _g98, _path147, _g99, _path148, _g100, _path149, _g101, _path150, _g102, _path151, _g103, _path152, _g104, _path153, _g105, _path154, _g106, _path155, _g107, _path156, _g108, _path157, _g109, _path158, _g110, _path159, _g111, _path160, _g112, _path161, _g113, _path162, _g114, _path163, _g115, _path164, _g116, _path165, _g117, _path166, _g118, _path167, _g119, _path168, _g120, _path169, _g121, _path170, _g122, _path171, _g123, _path172, _g124, _path173, _g125, _path174, _g126, _path175, _g127, _path176, _g128, _path177, _g129, _path178, _g130, _path179, _g131, _path180, _g132, _path181, _g133, _path182, _g134, _path183, _g135, _path184, _g136, _path185, _g137, _path186, _g138, _path187, _g139, _path188, _g140, _path189, _g141, _path190, _g142, _path191, _g143, _path192, _g144, _path193, _g145, _path194, _g146, _path195, _g147, _path196, _g148, _path197, _g149, _path198, _g150, _path199, _g151, _path200, _g152, _path201, _g153, _path202, _g154, _path203, _g155, _path204, _g156, _path205, _g157, _path206, _g158, _path207, _g159, _path208, _g160, _path209, _g161, _path210, _g162, _path211, _g163, _path212, _g164, _path213, _g165, _path214, _g166, _path215, _g167, _path216, _g168, _path217, _g169, _path218, _g170, _path219, _g171, _path220, _g172, _path221, _g173, _path222, _g174, _path223, _g175, _path224, _g176, _path225, _g177, _path226, _g178, _path227, _g179, _path228, _g180, _path229, _g181, _path230, _g182, _path231, _g183, _path232, _g184, _path233, _g185, _path234, _g186, _path235, _g187, _path236, _g188, _path237, _g189, _path238, _g190, _path239, _g191, _path240, _g192, _path241, _g193, _path242, _g194, _path243, _g195, _path244, _g196, _path245, _g197, _path246, _g198, _path247, _g199, _path248, _g200, _path249, _g201, _path250, _g202, _path251, _g203, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1164,
    height: 432,
    viewBox: "0 0 1164 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_911_37915",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1164,
    height: 432
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1164,
    height: 432,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_911_37915)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4299 87.1475C80.9354 85.2993 76.9191 80.8565 76.386 75.8451C75.45 67.1018 85.0701 56.6168 99.7845 55.1122C122.934 52.7546 132.27 28.6452 150.953 41.8787C154.519 44.4022 156.794 48.1223 157.683 52.3873C161.474 70.4427 140.587 98.3077 89.4299 87.1475Z",
    fill: "#418BE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4304 87.1474C80.9359 85.2992 76.9196 80.8564 76.3865 75.845C77.8674 75.3593 79.9288 75.4422 82.5353 76.3544C95.4726 80.8327 120.565 73.286 128.349 63.8199C134.853 55.9059 150.409 48.2407 157.695 52.3872C161.474 70.4426 140.587 98.3076 89.4304 87.1474Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4311 94.7655C11.3205 92.9647 6.49865 87.7756 6.16692 82.2547C5.68118 74.2222 14.6378 65.5025 33.6528 65.5025C61.968 65.5025 70.9364 41.9026 85.5561 52.7548C88.743 55.1124 90.8519 59.105 91.4679 63.761C93.6715 80.525 76.5521 105.843 20.4311 94.7655Z",
    fill: "#418BE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0083 154.215C48.5923 163.184 33.8304 159.879 25.869 151.384C25.715 151.218 25.5728 151.064 25.4425 150.91C15.3486 139.525 40.2873 143.043 53.7814 134.063C57.2645 131.741 60.2501 131.338 62.5603 132.156C69.3133 134.561 70.2611 147.534 61.0083 154.215Z",
    fill: "#418BE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6943 219.317L75.936 219.245C75.9716 218.902 79.2415 184.367 70.9128 171.193C66.8847 164.819 60.7359 164.049 54.8004 163.302C48.462 162.508 41.8986 161.679 38.3325 153.907L39.0197 153.587C42.408 160.968 48.4739 161.738 54.8951 162.544C61.0084 163.314 67.3349 164.108 71.5644 170.79C80.0234 184.177 76.8364 217.883 76.6943 219.317Z",
    fill: "#190064"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6854 168.373C58.8521 161.027 52.5612 149.322 52.502 149.204L53.1773 148.848C53.2365 148.967 59.4564 160.518 69.1475 167.768L68.6854 168.373Z",
    fill: "#190064"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5802 218.866L79.8338 218.748C89.9633 156.857 64.1598 127.5 52.5967 117.749C44.5524 110.972 41.5905 102.762 39.2092 96.1633C36.8634 89.6709 35.1574 84.9675 29.7432 85.1689L29.7195 84.4107C35.7142 84.1974 37.5624 89.3629 39.9319 95.9026C42.2895 102.407 45.2158 110.51 53.0943 117.157C60.416 123.329 70.4862 134.572 76.8838 153.031C83.3999 171.892 84.6438 194.046 80.5802 218.866Z",
    fill: "#190064"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5733 117.725C46.6615 111.802 48.4741 106.067 50.4052 100.002C51.2701 97.2648 52.1705 94.4451 52.4548 91.4122C53.3552 81.9817 45.7018 80.56 45.3701 80.5008L45.5004 79.7544C45.5834 79.7662 54.1727 81.3419 53.2131 91.4951C52.9169 94.5991 52.0046 97.4662 51.1279 100.238C49.185 106.328 47.5145 111.6 53.1064 117.192L52.5733 117.725Z",
    fill: "#190064"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0226 128.661C55.2862 110.214 61.1625 103.189 67.3824 95.7486C71.5882 90.7253 75.9362 85.5243 75.9362 76.3545H76.6944C76.6944 85.8087 72.2516 91.1045 67.9629 96.2344C61.8971 103.485 56.1629 110.333 63.7215 128.364L63.0226 128.661Z",
    fill: "#190064"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.142 168.586C74.7633 150.377 76.5997 129.324 84.7033 116.209C88.447 110.143 93.2334 106.447 98.541 105.499C122.449 101.246 138.17 84.6595 143.158 70.0991L143.881 70.3479C141.203 78.1672 135.706 85.939 128.384 92.23C120.008 99.4332 109.737 104.279 98.6713 106.245C93.5888 107.146 88.9802 110.736 85.3549 116.612C77.3579 129.549 75.5571 150.353 80.8766 168.373L80.142 168.586Z",
    fill: "#190064"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.507 137.629L77.7725 137.44C79.3482 131.468 79.4903 126.481 79.6088 122.074C79.7984 115.439 79.9642 109.717 85.106 103.686C88.2692 99.99 93.7072 96.4832 98.5053 93.3911C104.18 89.7302 109.547 86.2826 109.239 83.6881C109.097 82.5033 107.699 81.4252 105.057 80.4893L105.306 79.7666C108.279 80.8092 109.808 82.065 109.985 83.5933C110.341 86.6618 105.045 90.0738 98.9082 94.019C94.1574 97.0756 88.7668 100.547 85.6747 104.172C80.7106 110.001 80.5566 115.332 80.3552 122.085C80.2486 126.528 80.1064 131.575 78.507 137.629Z",
    fill: "#190064"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.381 101.27L113.978 100.63C127.697 91.9933 122.176 76.651 122.117 76.497L122.828 76.2363C122.899 76.3903 128.633 92.3014 114.381 101.27Z",
    fill: "#190064"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.431 94.7657C11.3203 92.9649 6.49847 87.7757 6.16675 82.2549C7.46996 82.3733 8.91534 82.5747 10.491 82.8591C45.5237 89.2329 57.2052 78.6177 65.3443 70.2298C72.3935 62.9673 85.1294 58.5127 91.4677 63.7848C93.6713 80.5251 76.5519 105.843 20.431 94.7657Z",
    fill: "#D3D3D3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0084 154.216C48.5924 163.184 33.8306 159.879 25.8691 151.384C25.7151 151.218 25.5729 151.064 25.4426 150.91C29.6484 147.285 38.7828 147.451 46.9456 149.026C56.613 150.898 51.4831 135.047 62.5723 132.156C69.3134 134.561 70.2612 147.534 61.0084 154.216Z",
    fill: "#D3D3D3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8967 228.439L93.6953 226.851C93.6834 226.745 92.3683 216.461 87.6294 216.461C86.9541 216.461 86.5276 216.627 86.3025 216.983C85.6983 217.942 86.7645 220.205 87.5583 221.84C88.2929 223.38 88.6601 224.198 88.3402 224.553C88.1151 224.802 87.7005 224.636 87.5583 224.589C86.5039 224.198 85.5443 224.482 85.0585 224.956C84.7505 225.264 84.632 225.631 84.7386 225.963C84.8453 226.283 85.3429 227.077 87.6531 227.361L87.6057 227.74C85.177 227.444 84.5491 226.579 84.3832 226.093C84.2174 225.608 84.3714 225.098 84.7979 224.695C85.3666 224.15 86.4921 223.795 87.7005 224.245C87.9967 224.352 88.0678 224.304 88.0678 224.304C88.2336 224.127 87.6294 222.859 87.2266 222.018C86.3617 220.193 85.2718 217.93 85.9945 216.793C86.2907 216.331 86.8356 216.094 87.6413 216.094C91.6812 216.094 93.3398 222.622 93.873 225.501C94.3469 222.018 95.8041 212.848 98.2209 211.083C98.5882 210.81 98.9673 210.715 99.3583 210.798C99.7729 210.881 100.128 211.142 100.389 211.557C102.095 214.246 100.164 223.368 99.6308 225.714C100.614 224.956 103.007 223.274 104.417 223.7C104.891 223.842 105.211 224.186 105.377 224.743L105.009 224.849C104.879 224.423 104.654 224.162 104.31 224.067C102.735 223.605 99.4768 226.33 99.4412 226.354L98.991 226.733L99.1332 226.164C99.1569 226.046 101.905 214.661 100.069 211.77C99.8559 211.438 99.5952 211.249 99.2754 211.177C98.991 211.118 98.7185 211.189 98.4342 211.403C95.6382 213.44 94.0862 226.745 94.0744 226.875L93.8967 228.439Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3246 222.421L74.0521 222.148C74.0995 222.101 75.3198 220.833 74.0403 219.364C72.9858 218.144 70.0595 220.193 69.0288 221.082L68.4128 221.615L68.7326 220.869C68.7682 220.786 72.3224 212.315 70.5927 208.583C70.2254 207.801 69.6449 207.28 68.863 207.031C68.1047 206.794 67.4768 206.889 66.9437 207.327C65.4865 208.512 65.0955 211.959 65.0363 214.838C65.6879 216.189 65.2377 218.926 65.1784 219.281L64.9415 220.679L64.8112 219.269C64.7993 219.091 64.6216 217.196 64.6572 214.909C64.5861 214.779 64.5031 214.672 64.3965 214.601C64.1359 214.412 63.7804 214.424 63.3184 214.649C60.6527 215.952 61.0556 219.127 61.0792 219.257L61.2214 220.3L60.7238 219.376C60.0485 218.132 58.8638 217.765 58.0582 217.824C57.4658 217.871 57.0274 218.144 56.8734 218.558C56.672 219.151 57.063 219.944 57.9752 220.809L57.7146 221.082C56.3166 219.767 56.364 218.854 56.5062 218.428C56.6957 217.871 57.2644 217.504 58.0108 217.445C58.7927 217.385 59.8827 217.67 60.6527 218.618C60.6764 217.504 60.9963 215.348 63.1288 214.305C63.7331 214.009 64.2188 214.009 64.6098 214.293C64.6216 214.305 64.6453 214.317 64.6572 214.329C64.7519 211.485 65.2021 208.239 66.6949 207.031C67.3228 206.521 68.0929 206.403 68.9696 206.675C69.8581 206.948 70.5216 207.54 70.9363 208.429C72.4646 211.722 70.178 218.227 69.3606 220.347C70.5216 219.471 73.1399 217.753 74.3364 219.127C75.8529 220.857 74.3364 222.409 74.3246 222.421Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M496.565 207.753L496.209 207.635C496.221 207.599 497.252 204.543 496.683 203.405C496.6 203.228 496.482 203.121 496.328 203.074C495.226 202.706 491.66 205.739 490.38 206.948L490.001 207.303L490.06 206.782C490.345 204.353 490.617 200.29 490.108 199.697C489.575 199.602 487.205 203.37 485.31 206.9L485.002 207.481L484.954 206.829C484.551 201.308 482.917 186.961 480.251 186.961C480.002 186.961 479.789 187.068 479.611 187.293C477.656 189.698 480.405 203.026 480.429 203.168L480.512 203.548L473.32 199.993L476.507 206.735L476.164 206.9L472.503 199.176L479.978 202.86C479.528 200.598 477.407 189.39 479.315 187.056C479.564 186.748 479.884 186.594 480.239 186.594C483.497 186.594 484.954 202.339 485.262 206.178C486.317 204.258 489.042 199.448 490.037 199.342C490.167 199.33 490.286 199.377 490.369 199.472C491.056 200.266 490.641 204.744 490.475 206.344C491.672 205.254 495.096 202.292 496.423 202.742C496.671 202.825 496.873 203.003 497.003 203.263C497.655 204.519 496.612 207.623 496.565 207.753Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M418.455 224.411L418.23 224.127C418.194 224.079 414.403 219.328 412.093 219.779C409.854 220.217 410.316 223.937 410.316 223.973L409.937 224.02C409.913 223.854 409.427 219.909 412.01 219.399C414.214 218.961 417.412 222.551 418.289 223.605C418.893 221.639 421.44 213.784 423.822 214.388C424.26 214.495 424.58 214.767 424.793 215.182C425.409 216.426 424.793 218.76 424.331 220.11C424.983 219.53 426.096 218.89 427.791 219.08C428.43 219.151 428.857 219.423 429.082 219.885C429.745 221.283 428.004 223.984 427.933 224.103L427.613 223.901C427.625 223.878 429.307 221.26 428.738 220.051C428.584 219.719 428.253 219.53 427.755 219.471C425.054 219.163 423.964 221.141 423.952 221.165L423.608 220.999C423.62 220.963 425.267 216.971 424.461 215.36C424.307 215.04 424.071 214.85 423.739 214.767C421.891 214.293 419.367 221.319 418.562 224.067L418.455 224.411Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.246 256.683C167.457 255.131 166.651 253.65 167.149 252.821C167.634 252.015 169.151 252.027 171.437 252.868C171.674 251.719 172.859 246.613 174.98 245.334C175.477 245.025 175.999 244.954 176.532 245.12C179.351 245.985 178.724 251.613 178.427 253.52C179.245 252.75 181.223 251.222 184.541 250.7C185.808 250.499 186.732 250.736 187.301 251.388C188.415 252.655 187.716 255.037 187.68 255.143L187.313 255.037C187.325 255.013 187.976 252.75 187.005 251.636C186.531 251.091 185.714 250.902 184.588 251.079C180.323 251.755 178.297 254.207 178.273 254.231L177.788 254.823L177.942 254.077C177.953 254.006 179.423 246.412 176.413 245.499C175.987 245.369 175.572 245.428 175.169 245.677C172.978 247.004 171.769 253.117 171.757 253.176L171.71 253.402L171.497 253.319C169.352 252.501 167.836 252.395 167.457 253.034C167.137 253.567 167.634 254.823 169.483 256.423L169.246 256.683Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M495.333 141.337C490.475 141.207 487.288 138.328 485.855 134.561C482.988 127.026 487.087 115.925 498.626 116.079C504.123 116.15 507.476 118.768 508.981 122.299C512.18 129.881 506.765 141.657 495.333 141.337Z",
    fill: "#418BE2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M572.802 88.7939C571.12 98.7338 553.586 106.198 543.113 99.7408C540.945 98.4021 539.961 97.1463 539.784 95.9023C539.108 91.4714 548.693 87.4077 549.984 81.6144C551.631 74.1979 562.614 68.7007 571.132 81.6144C572.731 84.0431 573.193 86.4836 572.802 88.7939Z",
    fill: "#418BE2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M541.407 84.4701C539.547 92.858 525.768 100.642 513.187 101.116C500.676 101.578 489.776 91.4482 488.603 80.5605C488.212 76.9352 488.899 73.2388 490.949 69.8031C499.183 56.072 512.097 75.5727 521.432 74.7434C530.768 73.9141 537.912 70.0755 541.206 79.9562C541.691 81.4609 541.739 82.9773 541.407 84.4701Z",
    fill: "#418BE2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M518.139 196.7H517.38C517.38 166.359 511.931 149.69 507.357 141.053C502.417 131.717 497.418 129.49 497.37 129.478L497.666 128.779C497.88 128.874 502.903 131.078 507.974 140.603C512.618 149.311 518.139 166.122 518.139 196.7Z",
    fill: "#190064"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M517.996 187.365H517.238C517.238 186.832 517.475 133.625 517.475 118.958C517.475 104.457 500.462 87.2664 500.285 87.1005L500.818 86.5674C501.529 87.2782 518.233 104.149 518.233 118.97C518.233 133.625 517.996 186.832 517.996 187.365Z",
    fill: "#190064"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M510.236 86.7416L509.491 86.8843L512.691 103.581L513.435 103.438L510.236 86.7416Z",
    fill: "#190064"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M517.997 134.063H517.239C517.239 114.171 534.95 101.009 545.53 93.1421C550.103 89.7419 553.728 87.0525 553.728 85.4531H554.487C554.487 87.4316 551.11 89.9433 545.992 93.7463C535.519 101.53 517.997 114.55 517.997 134.063Z",
    fill: "#190064"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M536.052 101.554L535.519 101.021C538.777 97.7626 545.115 96.2935 551.24 94.8718C558.455 93.2013 565.268 91.6256 565.268 87.3843H566.026C566.026 92.2298 558.929 93.8766 551.418 95.6182C545.388 97.0043 539.156 98.4379 536.052 101.554Z",
    fill: "#190064"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M541.407 84.4698C539.547 92.8577 525.768 100.641 513.186 101.115C500.675 101.577 489.776 91.4479 488.603 80.5602C488.603 80.5602 494.444 74.5891 504.881 81.2947C515.307 88.0003 533.457 92.1232 541.407 84.4698Z",
    fill: "#D3D3D3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M572.802 88.7944C571.12 98.7344 553.586 106.198 543.113 99.7414C540.945 98.4026 539.962 97.1468 539.784 95.9028C540.59 91.1994 551.963 90.5241 558.787 92.7159C562.993 94.0784 568.845 91.235 572.802 88.7944Z",
    fill: "#D3D3D3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M495.333 141.337C490.475 141.207 487.288 138.328 485.855 134.56C488.082 132.203 494.089 134.383 497.418 133.968C507.997 132.617 502.062 120.663 508.981 122.31C512.18 129.881 506.765 141.657 495.333 141.337Z",
    fill: "#D3D3D3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M397.389 328.769H952V388.268H378.263L397.389 328.769Z",
    fill: "#343643"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M254.997 426.064C349.833 426.064 426.713 399.14 426.713 365.927C426.713 332.714 349.833 305.79 254.997 305.79C160.161 305.79 83.2812 332.714 83.2812 365.927C83.2812 399.14 160.161 426.064 254.997 426.064Z",
    fill: "#343643"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M422.223 313.408C411.169 366.78 330.773 392.832 246.562 372.479C162.351 352.125 104.453 292.687 117.248 239.717C130.043 186.747 174.85 144.452 292.826 165.114C378.162 180.066 438.193 236.317 422.223 313.408Z",
    fill: "#3D5B81"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M423.872 288.271C435.911 238.454 378.713 181.888 296.117 161.927C213.521 141.966 136.804 166.17 124.765 215.987C112.726 265.804 169.923 322.37 252.52 342.331C335.116 362.292 411.833 338.088 423.872 288.271Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M421.725 274.868C421.618 278.446 421.145 282 420.292 285.519C418.988 290.933 416.844 296.016 413.941 300.743C409.096 308.633 402.153 315.552 393.528 321.345C388.576 324.663 383.079 327.624 377.096 330.195C368.696 333.809 359.337 336.64 349.255 338.654C344.232 339.65 339.031 340.443 333.664 341.024C324.091 342.055 314.033 342.398 303.631 342.019C299.531 341.865 295.385 341.604 291.191 341.225C281.346 340.337 271.264 338.796 261.063 336.593C259.013 336.155 256.964 335.681 254.914 335.183C254.772 335.148 254.618 335.112 254.476 335.076C247.687 333.418 241.077 331.522 234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167C133.337 257.595 125.517 235.89 130.446 215.489C141.748 168.728 215.794 146.502 295.835 165.837C330.311 174.166 360.261 188.844 382.309 206.604C407.591 226.969 422.448 251.375 421.725 274.868Z",
    fill: "#343643"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M388.434 400.237C382.333 405.711 373.755 406.67 366.801 403.353C364.502 402.263 362.393 400.711 360.593 398.709L344.066 380.263C336.803 372.147 337.478 359.684 345.594 352.409C345.997 352.054 346.4 351.71 346.826 351.391C350.357 348.701 354.562 347.374 358.744 347.374C364.159 347.374 369.549 349.59 373.435 353.938L389.962 372.384C397.237 380.511 396.549 392.975 388.434 400.237Z",
    fill: "#DFFBFC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 403.306C366.836 403.318 366.824 403.341 366.812 403.353C364.514 402.263 362.405 400.711 360.604 398.709L344.077 380.263C336.815 372.147 337.49 359.684 345.606 352.409C346.008 352.054 346.411 351.711 346.838 351.391L368.4 375.464C375.651 383.58 374.963 396.043 366.86 403.306Z",
    fill: "#98C0D9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M458.262 432H370.118L365.557 426.905C357.702 418.138 355.25 406.398 357.986 395.782C358.65 393.2 359.621 390.676 360.901 388.283C362.725 384.883 365.154 381.743 368.187 379.018C368.779 378.485 369.384 377.988 370 377.502C375.426 373.272 381.8 370.939 388.256 370.465C389.109 370.394 389.951 370.37 390.804 370.37C400.104 370.37 409.38 374.173 416.074 381.66L451.912 421.681C454.708 424.808 456.829 428.315 458.262 432Z",
    fill: "#343643"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M434.816 432H370.118L365.557 426.905C357.702 418.138 355.25 406.398 357.986 395.782C358.65 393.2 359.621 390.676 360.901 388.283C364.716 386.233 368.815 384.978 372.985 384.492C374.288 384.338 375.592 384.267 376.895 384.267C383.079 384.267 389.24 385.949 394.642 389.266C397.379 390.949 399.914 393.046 402.165 395.557L434.816 432Z",
    fill: "#252730"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M421.725 274.868C421.618 278.446 421.144 282 420.291 285.519C418.988 290.933 416.843 296.016 413.941 300.743C409.095 308.633 402.153 315.552 393.528 321.346C388.576 324.663 383.078 327.625 377.096 330.195C368.696 333.809 359.336 336.64 349.254 338.655C344.231 339.65 339.03 340.443 333.663 341.024C324.09 342.055 314.032 342.398 303.63 342.019C299.531 341.865 295.384 341.604 291.19 341.225C281.345 340.337 271.263 338.797 261.062 336.593C259.013 336.155 256.963 335.681 254.914 335.183C254.772 335.148 254.618 335.112 254.475 335.077L255.553 314.438L283.691 315.517L285.16 287.391L313.297 288.469L314.767 260.355L342.904 261.433L344.373 233.308L372.511 234.386L373.98 206.26L382.296 206.58C407.591 226.969 422.447 251.375 421.725 274.868Z",
    fill: "#D53B5C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M261.062 336.593C259.013 336.155 256.963 335.681 254.914 335.183C254.772 335.148 254.618 335.112 254.475 335.077L255.553 314.438L261.062 336.593Z",
    fill: "#9D2C44"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M303.642 342.019C299.543 341.865 295.397 341.605 291.203 341.225L283.691 315.528L285.16 287.403L303.642 342.019Z",
    fill: "#9D2C44"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M349.254 338.655C344.231 339.65 339.03 340.444 333.663 341.024L313.298 288.493L314.767 260.379L349.254 338.655Z",
    fill: "#9D2C44"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M393.54 321.345C388.588 324.663 383.091 327.625 377.108 330.195L342.916 261.445L344.385 233.32L393.54 321.345Z",
    fill: "#9D2C44"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M421.725 274.868C421.618 278.446 421.144 282.001 420.291 285.519C418.988 290.933 416.844 296.016 413.941 300.743L372.511 234.398L373.98 206.272L421.725 274.868Z",
    fill: "#9D2C44"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M127.875 253.519L120.908 281.763C122.306 285.827 124.451 290.092 127.14 294.499L136.12 269.584L127.875 253.519Z",
    fill: "#98C0D9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M373.992 210.845H952V280.555L421.725 279.43L373.992 210.845Z",
    fill: "#9D2C44"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M373.992 206.284H952V275.994L421.725 274.869L373.992 206.284Z",
    fill: "#D53B5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 207.185L254.417 204.152H259.985V207.185Z",
    fill: "#DFFBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 207.943L253.031 204.152H254.417L259.985 207.185V207.943Z",
    fill: "#DFFBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 208.689L251.644 204.152H253.03L259.985 207.943V208.689Z",
    fill: "#DEFAFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 209.447L250.246 204.152H251.644L259.985 208.689V209.447Z",
    fill: "#DDF9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.206L248.86 204.152H250.246L259.985 209.447V210.206Z",
    fill: "#DCF8F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.964L247.474 204.152H248.86L259.985 210.206V210.964Z",
    fill: "#DBF7F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.984 211.722L246.076 204.152H247.474L259.984 210.964V211.722Z",
    fill: "#DAF6F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 212.48L244.69 204.152H246.076L259.985 211.722V212.48Z",
    fill: "#DAF5F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 213.239L243.304 204.152H244.69L259.985 212.48V213.239Z",
    fill: "#D9F4F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 213.997L241.906 204.152H243.304L259.985 213.239V213.997Z",
    fill: "#D8F3F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 214.755L240.52 204.152H241.906L259.985 213.997V214.755Z",
    fill: "#D7F2F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 215.501L239.134 204.152H240.52L259.985 214.755V215.501Z",
    fill: "#D6F1F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 216.26L237.735 204.152H239.133L259.985 215.501V216.26Z",
    fill: "#D5F0F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 217.018L236.349 204.152H237.736L259.985 216.26V217.018Z",
    fill: "#D4EFF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 217.776L234.963 204.152H236.35L259.985 217.018V217.776Z",
    fill: "#D3EEF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 218.534L233.565 204.152H234.963L259.985 217.776V218.534Z",
    fill: "#D2EDEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.984 219.293L232.179 204.152H233.565L259.984 218.534V219.293Z",
    fill: "#D1ECEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 220.051L230.793 204.152H232.179L259.985 219.293V220.051Z",
    fill: "#D0EBED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 220.809L229.395 204.152H230.793L259.985 220.051V220.809Z",
    fill: "#D0EAEC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 221.555L228.009 204.152H229.395L259.985 220.809V221.555Z",
    fill: "#CFE9EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 222.314L226.623 204.152H228.009L259.985 221.555V222.314Z",
    fill: "#CEE8EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 223.072L225.225 204.152H226.623L259.985 222.314V223.072Z",
    fill: "#CDE7E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 223.83L223.838 204.152H225.225L259.985 223.072V223.83Z",
    fill: "#CCE6E8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 224.588L222.452 204.152H223.839L259.985 223.83V224.588Z",
    fill: "#CBE5E7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 225.347L221.054 204.152H222.452L259.985 224.588V225.347Z",
    fill: "#CAE4E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 226.105L219.668 204.152H221.054L259.985 225.347V226.105Z",
    fill: "#C9E3E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 226.863L218.282 204.152H219.669L259.985 226.105V226.863Z",
    fill: "#C8E2E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 227.621L216.884 204.152H218.282L259.985 226.863V227.621Z",
    fill: "#C7E1E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 228.368L215.498 204.152H216.884L259.985 227.621V228.368Z",
    fill: "#C6E0E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 229.126L214.112 204.152H215.498L259.985 228.368V229.126Z",
    fill: "#C6DFE2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 229.884L212.714 204.152H214.112L259.985 229.126V229.884Z",
    fill: "#C5DEE1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 230.642L211.328 204.152H212.714L259.985 229.884V230.642Z",
    fill: "#C4DDE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 231.401L209.941 204.152H211.328L259.985 230.642V231.401Z",
    fill: "#C3DCDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 232.159L208.544 204.152H209.942L259.985 231.401V232.159Z",
    fill: "#C2DBDE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.984 232.917L207.157 204.152H208.543L259.984 232.159V232.917Z",
    fill: "#C1DADD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 233.675L205.771 204.152H207.157L259.985 232.917V233.675Z",
    fill: "#C0D9DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 234.422L204.374 204.152H205.772L259.985 233.675V234.422Z",
    fill: "#BFD8DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 235.18L202.987 204.152H204.373L259.985 234.422V235.18Z",
    fill: "#BED7DA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 235.938L201.601 204.152H202.987L259.985 235.18V235.938Z",
    fill: "#BDD6D9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 236.696L200.203 204.152H201.601L259.985 235.938V236.696Z",
    fill: "#BCD5D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 237.455L198.817 204.152H200.203L259.985 236.696V237.455Z",
    fill: "#BCD4D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 238.213L197.431 204.152H198.817L259.985 237.455V238.213Z",
    fill: "#BBD3D7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 238.971L196.033 204.152H197.431L259.985 238.213V238.971Z",
    fill: "#BAD2D6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 239.729L194.647 204.152H196.033L259.985 238.971V239.729Z",
    fill: "#B9D1D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 240.487L193.261 204.152H194.647L259.985 239.729V240.487Z",
    fill: "#B8D0D4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 241.234L191.862 204.152H193.26L259.985 240.487V241.234Z",
    fill: "#B7CFD3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 241.992L190.476 204.152H191.862L259.985 241.234V241.992Z",
    fill: "#B6CED2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 242.75L189.22 204.223L189.256 204.152H190.476L259.985 241.992V242.75Z",
    fill: "#B5CDD1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 243.509L188.901 204.815L189.221 204.223L259.985 242.751V243.509Z",
    fill: "#B4CCD0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 244.267L188.581 205.396L188.901 204.815L259.985 243.509V244.267Z",
    fill: "#B3CBCF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 245.025L188.261 205.976L188.581 205.396L259.985 244.267V245.025Z",
    fill: "#B2CACE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 245.783L187.941 206.557L188.261 205.976L259.985 245.025V245.783Z",
    fill: "#B2C9CD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 246.541L187.633 207.149L187.941 206.557L259.985 245.783V246.541Z",
    fill: "#B1C8CC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 247.288L187.313 207.729L187.633 207.149L259.985 246.541V247.288Z",
    fill: "#B0C7CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 248.046L186.993 208.31L187.313 207.729L259.985 247.288V248.046Z",
    fill: "#AFC6CA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 248.805L186.673 208.891L186.993 208.31L259.985 248.046V248.805Z",
    fill: "#AEC5CA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 249.563L186.354 209.483L186.673 208.891L259.985 248.804V249.563Z",
    fill: "#ADC4C9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 250.321L186.033 210.063L186.353 209.483L259.985 249.563V250.321Z",
    fill: "#ACC3C8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 251.079L185.726 210.644L186.034 210.063L259.985 250.321V251.079Z",
    fill: "#ABC2C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 251.837L185.406 211.236L185.725 210.644L259.985 251.079V251.837Z",
    fill: "#AAC1C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 252.595L185.086 211.817L185.406 211.236L259.985 251.837V252.595Z",
    fill: "#A9C0C5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 253.354L184.766 212.397L185.086 211.817L259.985 252.596V253.354Z",
    fill: "#A8BFC4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 254.1L184.446 212.978L184.766 212.397L259.985 253.354V254.1Z",
    fill: "#A7BEC3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 254.858L184.126 213.57L184.446 212.978L259.985 254.1V254.858Z",
    fill: "#A7BDC2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 255.617L183.818 214.151L184.126 213.57L259.985 254.858V255.617Z",
    fill: "#A6BCC1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 256.375L183.498 214.731L183.818 214.151L259.985 255.617V256.375Z",
    fill: "#A5BBC0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 257.133L183.178 215.324L183.498 214.731L259.985 256.375V257.133Z",
    fill: "#A4BABF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 257.891L182.858 215.904L183.178 215.324L259.985 257.133V257.891Z",
    fill: "#A3B9BE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 258.65L182.539 216.485L182.859 215.904L259.985 257.891V258.65Z",
    fill: "#A2B8BD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 259.408L182.23 217.065L182.539 216.485L259.985 258.65V259.408Z",
    fill: "#A1B7BC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 260.154L181.911 217.658L182.231 217.065L259.985 259.408V260.154Z",
    fill: "#A0B6BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 260.912L181.591 218.238L181.91 217.658L259.985 260.154V260.912Z",
    fill: "#9FB5BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 261.671L181.271 218.819L181.591 218.238L259.985 260.912V261.671Z",
    fill: "#9EB4BA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.984 262.429L180.951 219.399L181.271 218.819L259.984 261.671V262.429Z",
    fill: "#9DB3B9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.984 263.187L180.631 219.992L180.951 219.399L259.984 262.429V263.187Z",
    fill: "#9DB2B8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 263.945L180.323 220.572L180.631 219.992L259.985 263.187V263.945Z",
    fill: "#9CB1B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 264.704L180.003 221.153L180.323 220.572L259.985 263.945V264.704Z",
    fill: "#9BB0B6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 265.462L179.683 221.745L180.003 221.153L259.985 264.704V265.462Z",
    fill: "#9AAFB5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 266.22L179.364 222.326L179.684 221.745L259.985 265.462V266.22Z",
    fill: "#99AEB4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 266.966L179.043 222.906L179.363 222.325L259.985 266.22V266.966Z",
    fill: "#98ADB3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 267.725L178.724 223.487L179.044 222.906L259.985 266.967V267.725Z",
    fill: "#97ACB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 268.483L178.416 224.079L178.724 223.487L259.985 267.725V268.483Z",
    fill: "#96ABB1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 269.241L178.096 224.66L178.416 224.079L259.985 268.483V269.241Z",
    fill: "#95AAB0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 269.999L177.776 225.24L178.096 224.659L259.985 269.241V269.999Z",
    fill: "#94A9AF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 270.758L177.456 225.82L177.776 225.24L259.985 269.999V270.758Z",
    fill: "#93A8AE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 271.516L177.136 226.413L177.456 225.821L259.985 270.758V271.516Z",
    fill: "#93A7AD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 272.274L176.816 226.993L177.136 226.413L259.985 271.516V272.274Z",
    fill: "#92A6AD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 273.021L176.508 227.574L176.816 226.994L259.985 272.274V273.021Z",
    fill: "#91A5AC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 273.779L176.188 228.166L176.508 227.574L259.985 273.02V273.779Z",
    fill: "#90A4AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 274.537L175.868 228.747L176.188 228.167L259.985 273.779V274.537Z",
    fill: "#8FA3AA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 275.295L175.549 229.328L175.868 228.747L259.985 274.537V275.295Z",
    fill: "#8EA2A9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 276.053L175.229 229.908L175.549 229.327L259.985 275.295V276.053Z",
    fill: "#8DA1A8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 276.811L174.909 230.5L175.229 229.908L259.985 276.053V276.811Z",
    fill: "#8CA0A7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 277.57L174.601 231.081L174.909 230.5L259.985 276.812V277.57Z",
    fill: "#8B9FA6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 278.328L174.281 231.661L174.601 231.081L259.985 277.57V278.328Z",
    fill: "#8A9EA5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 279.086L173.961 232.254L174.281 231.661L259.985 278.328V279.086Z",
    fill: "#899DA4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 279.833L173.641 232.834L173.961 232.254L259.985 279.086V279.833Z",
    fill: "#899CA3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 280.591L173.321 233.415L173.641 232.834L259.985 279.833V280.591Z",
    fill: "#889BA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 281.349L173.002 233.995L173.322 233.415L259.985 280.591V281.349Z",
    fill: "#879AA1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 282.107L172.694 234.587L173.002 233.995L259.985 281.349V282.107Z",
    fill: "#8699A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 282.866L172.374 235.168L172.693 234.588L259.985 282.107V282.866Z",
    fill: "#85989F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 283.624L172.054 235.748L172.374 235.168L259.985 282.865V283.624Z",
    fill: "#84979F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 284.382L171.734 236.329L172.054 235.749L259.985 283.624V284.382Z",
    fill: "#83959E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.985 284.5L259.712 284.986L171.414 236.921L171.734 236.329L259.985 284.382V284.5Z",
    fill: "#82949D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 198,
    width: 105,
    height: 128
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M192.599 198.058L284.495 276.921C256.809 302.87 226.027 319.863 198.308 325.977L180.697 205.622L192.599 198.058Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.428 236.918L171.111 237.5L259.412 285.577L259.73 284.994L171.428 236.918Z",
    fill: "#81939C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 198,
    width: 104,
    height: 129
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M191.922 198.092L283.818 276.954C256.132 302.904 225.35 319.896 197.631 326.011L180.02 205.655L191.922 198.092Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.119 237.515L170.801 238.098L259.103 286.174L259.42 285.592L171.119 237.515Z",
    fill: "#80929B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 198,
    width: 105,
    height: 129
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M191.242 198.112L283.139 276.974C255.453 302.924 224.671 319.916 196.951 326.031L179.341 205.675L191.242 198.112Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.801 238.083L170.484 238.666L258.785 286.743L259.103 286.16L170.801 238.083Z",
    fill: "#7F919A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 198,
    width: 105,
    height: 129
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M190.563 198.134L282.46 276.997C254.773 302.946 223.991 319.939 196.272 326.053L178.661 205.698L190.563 198.134Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.479 238.664L170.162 239.247L258.463 287.323L258.781 286.741L170.479 238.664Z",
    fill: "#7F9099"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 198,
    width: 105,
    height: 129
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M189.885 198.163L281.781 277.025C254.095 302.975 223.313 319.967 195.594 326.082L177.983 205.726L189.885 198.163Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.158 239.252L169.841 239.834L258.142 287.911L258.459 287.328L170.158 239.252Z",
    fill: "#7E8F98"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 198,
    width: 105,
    height: 129
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M189.206 198.185L281.102 277.048C253.416 302.997 222.634 319.99 194.915 326.104L177.304 205.748L189.206 198.185Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.847 239.838L169.529 240.421L257.831 288.497L258.148 287.915L169.847 239.838Z",
    fill: "#7D8E97"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 198,
    width: 105,
    height: 129
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M188.529 198.22L280.425 277.082C252.739 303.032 221.957 320.025 194.238 326.139L176.627 205.783L188.529 198.22Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.527 240.431L169.209 241.014L257.511 289.091L257.828 288.508L169.527 240.431Z",
    fill: "#7C8D96"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 198,
    width: 105,
    height: 129
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M187.849 198.24L279.746 277.102C252.06 303.051 221.278 320.044 193.558 326.159L175.948 205.803L187.849 198.24Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.204 241.009L168.886 241.592L257.188 289.669L257.505 289.086L169.204 241.009Z",
    fill: "#7B8C95"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 198,
    width: 105,
    height: 129
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M187.17 198.262L279.066 277.124C251.38 303.073 220.598 320.066 192.879 326.181L175.268 205.825L187.17 198.262Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.898 241.585L168.58 242.168L256.882 290.245L257.199 289.662L168.898 241.585Z",
    fill: "#7A8B94"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 198,
    width: 105,
    height: 129
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M186.492 198.291L278.389 277.153C250.703 303.103 219.921 320.096 192.201 326.21L174.591 205.854L186.492 198.291Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.577 242.173L168.259 242.756L256.561 290.833L256.878 290.25L168.577 242.173Z",
    fill: "#798A93"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 198,
    width: 105,
    height: 129
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M185.813 198.312L277.709 277.174C250.023 303.124 219.241 320.116 191.522 326.231L173.911 205.875L185.813 198.312Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.254 242.753L167.937 243.335L256.238 291.412L256.555 290.829L168.254 242.753Z",
    fill: "#788992"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 198,
    width: 105,
    height: 129
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M185.135 198.341L277.032 277.204C249.345 303.153 218.563 320.146 190.844 326.26L173.233 205.905L185.135 198.341Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.933 243.341L167.615 243.924L255.917 292L256.234 291.418L167.933 243.341Z",
    fill: "#778891"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 198,
    width: 105,
    height: 129
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M184.458 198.373L276.354 277.235C248.668 303.185 217.886 320.177 190.167 326.292L172.556 205.936L184.458 198.373Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.623 243.936L167.305 244.519L255.607 292.596L255.924 292.013L167.623 243.936Z",
    fill: "#768790"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 198,
    width: 105,
    height: 129
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M183.778 198.389L275.674 277.251C247.988 303.201 217.206 320.194 189.487 326.308L171.876 205.952L183.778 198.389Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.299 244.511L166.982 245.094L255.283 293.171L255.601 292.588L167.299 244.511Z",
    fill: "#758690"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 198,
    width: 104,
    height: 129
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M183.099 198.418L274.996 277.28C247.31 303.23 216.528 320.222 188.808 326.337L171.198 205.981L183.099 198.418Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.984 245.088L166.667 245.671L254.968 293.747L255.285 293.165L166.984 245.088Z",
    fill: "#75858F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 198,
    width: 105,
    height: 129
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M182.42 198.44L274.317 277.302C246.631 303.252 215.849 320.245 188.129 326.359L170.519 206.003L182.42 198.44Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.662 245.669L166.344 246.252L254.646 294.328L254.963 293.746L166.662 245.669Z",
    fill: "#74848E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 198,
    width: 105,
    height: 129
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M181.742 198.469L273.638 277.331C245.952 303.281 215.17 320.273 187.451 326.388L169.84 206.032L181.742 198.469Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.351 246.262L166.033 246.844L254.335 294.921L254.652 294.338L166.351 246.262Z",
    fill: "#73838D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 198,
    width: 104,
    height: 129
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M181.064 198.494L272.96 277.357C245.274 303.306 214.492 320.299 186.773 326.413L169.162 206.058L181.064 198.494Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.029 246.846L165.712 247.428L254.013 295.505L254.331 294.922L166.029 246.846Z",
    fill: "#72828C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 198,
    width: 105,
    height: 129
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M180.386 198.523L272.282 277.386C244.596 303.335 213.814 320.328 186.095 326.442L168.484 206.087L180.386 198.523Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.708 247.433L165.391 248.016L253.692 296.093L254.009 295.51L165.708 247.433Z",
    fill: "#71818B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 198,
    width: 105,
    height: 129
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M179.706 198.545L271.603 277.407C243.917 303.356 213.134 320.349 185.415 326.464L167.805 206.108L179.706 198.545Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.401 248.009L165.084 248.591L253.386 296.668L253.703 296.085L165.401 248.009Z",
    fill: "#70808A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 198,
    width: 104,
    height: 129
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M179.027 198.567L270.924 277.43C243.238 303.379 212.455 320.372 184.736 326.486L167.126 206.131L179.027 198.567Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.08 248.59L164.762 249.173L253.064 297.249L253.381 296.667L165.08 248.59Z",
    fill: "#6F7F89"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 198,
    width: 105,
    height: 129
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M178.35 198.596L270.246 277.459C242.56 303.408 211.778 320.401 184.059 326.515L166.448 206.16L178.35 198.596Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.759 249.177L164.442 249.76L252.743 297.837L253.06 297.254L164.759 249.177Z",
    fill: "#6E7E88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 198,
    width: 105,
    height: 129
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M177.671 198.622L269.567 277.484C241.881 303.434 211.099 320.426 183.38 326.541L165.769 206.185L177.671 198.622Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.437 249.761L164.12 250.344L252.421 298.421L252.739 297.838L164.437 249.761Z",
    fill: "#6D7D87"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 198,
    width: 104,
    height: 129
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M176.992 198.645L268.888 277.507C241.202 303.457 210.42 320.449 182.701 326.564L165.09 206.208L176.992 198.645Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.126 250.348L163.808 250.931L252.11 299.008L252.427 298.425L164.126 250.348Z",
    fill: "#6C7C86"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 198,
    width: 105,
    height: 129
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M176.314 198.678L268.211 277.54C240.525 303.49 209.743 320.483 182.023 326.597L164.413 206.241L176.314 198.678Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.805 250.94L163.488 251.523L251.789 299.6L252.107 299.017L163.805 250.94Z",
    fill: "#6B7B85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 198,
    width: 105,
    height: 129
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M175.634 198.695L267.531 277.558C239.845 303.507 209.063 320.5 181.343 326.614L163.733 206.258L175.634 198.695Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.488 251.506L163.17 252.088L251.472 300.165L251.789 299.582L163.488 251.506Z",
    fill: "#6B7A84"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 198,
    width: 104,
    height: 129
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M174.956 198.724L266.853 277.586C239.167 303.536 208.385 320.528 180.665 326.643L163.055 206.287L174.956 198.724Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.166 252.093L162.849 252.675L251.151 300.752L251.468 300.169L163.166 252.093Z",
    fill: "#6A7983"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 198,
    width: 105,
    height: 129
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M174.278 198.749L266.174 277.612C238.488 303.561 207.706 320.554 179.987 326.668L162.376 206.313L174.278 198.749Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.855 252.682L162.538 253.265L250.839 301.342L251.156 300.759L162.855 252.682Z",
    fill: "#697882"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 198,
    width: 105,
    height: 129
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M173.599 198.771L265.495 277.634C237.809 303.583 207.027 320.576 179.308 326.69L161.697 206.335L173.599 198.771Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.533 253.263L162.216 253.846L250.517 301.922L250.834 301.34L162.533 253.263Z",
    fill: "#687782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 198,
    width: 104,
    height: 129
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M172.921 198.8L264.817 277.663C237.131 303.612 206.349 320.605 178.63 326.719L161.019 206.364L172.921 198.8Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.212 253.85L161.894 254.433L250.196 302.51L250.513 301.927L162.212 253.85Z",
    fill: "#677681"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 198,
    width: 105,
    height: 129
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M172.243 198.828L264.139 277.691C236.453 303.64 205.671 320.633 177.952 326.747L160.341 206.392L172.243 198.828Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.901 254.443L161.584 255.026L249.885 303.102L250.203 302.52L161.901 254.443Z",
    fill: "#667580"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 198,
    width: 105,
    height: 129
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M171.564 198.851L263.46 277.714C235.774 303.663 204.992 320.656 177.273 326.77L159.662 206.414L171.564 198.851Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.585 255.014L161.267 255.597L249.569 303.673L249.886 303.091L161.585 255.014Z",
    fill: "#65747F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 198,
    width: 105,
    height: 129
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M170.885 198.877L262.782 277.74C235.095 303.689 204.313 320.682 176.594 326.796L158.983 206.441L170.885 198.877Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.263 255.599L160.946 256.181L249.247 304.258L249.564 303.675L161.263 255.599Z",
    fill: "#64737E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 198,
    width: 105,
    height: 129
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M170.206 198.898L262.102 277.761C234.416 303.71 203.634 320.703 175.915 326.817L158.304 206.462L170.206 198.898Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.941 256.178L160.624 256.761L248.925 304.837L249.242 304.255L160.941 256.178Z",
    fill: "#63727D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 198,
    width: 105,
    height: 129
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M169.528 198.928L261.424 277.79C233.738 303.739 202.956 320.732 175.237 326.847L157.626 206.491L169.528 198.928Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.63 256.772L160.312 257.354L248.614 305.431L248.931 304.848L160.63 256.772Z",
    fill: "#62717C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 198,
    width: 105,
    height: 129
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M168.85 198.956L260.746 277.818C233.06 303.768 202.278 320.76 174.559 326.875L156.948 206.519L168.85 198.956Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.308 257.359L159.991 257.941L248.293 306.018L248.61 305.435L160.308 257.359Z",
    fill: "#61707B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 198,
    width: 105,
    height: 129
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M168.171 198.979L260.067 277.841C232.381 303.79 201.599 320.783 173.88 326.898L156.269 206.542L168.171 198.979Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.986 257.94L159.669 258.522L247.971 306.599L248.288 306.016L159.986 257.94Z",
    fill: "#616F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 199,
    width: 105,
    height: 128
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M167.492 199.004L259.388 277.867C231.702 303.816 200.92 320.809 173.201 326.923L155.59 206.567L167.492 199.004Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.67 258.513L159.353 259.096L247.654 307.173L247.972 306.59L159.67 258.513Z",
    fill: "#606E79"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 199,
    width: 105,
    height: 128
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M166.813 199.026L258.71 277.889C231.023 303.838 200.241 320.831 172.522 326.945L154.911 206.589L166.813 199.026Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.358 259.1L159.041 259.682L247.342 307.759L247.66 307.176L159.358 259.1Z",
    fill: "#5F6D78"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 199,
    width: 105,
    height: 128
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M166.135 199.055L258.031 277.917C230.345 303.867 199.563 320.86 171.844 326.974L154.233 206.618L166.135 199.055Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.038 259.687L158.721 260.27L247.022 308.346L247.339 307.764L159.038 259.687Z",
    fill: "#5E6C77"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 199,
    width: 105,
    height: 128
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M165.456 199.077L257.352 277.94C229.666 303.889 198.884 320.882 171.165 326.996L153.554 206.641L165.456 199.077Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.716 260.268L158.398 260.851L246.7 308.927L247.017 308.345L158.716 260.268Z",
    fill: "#5D6B76"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 199,
    width: 105,
    height: 129
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M164.779 199.113L256.675 277.975C228.989 303.925 198.207 320.917 170.488 327.032L152.877 206.676L164.779 199.113Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.406 260.868L158.088 261.45L246.39 309.527L246.707 308.944L158.406 260.868Z",
    fill: "#5C6A75"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 199,
    width: 104,
    height: 129
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M164.099 199.131L255.995 277.993C228.309 303.943 197.527 320.935 169.808 327.05L152.197 206.694L164.099 199.131Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.083 261.444L157.766 262.027L246.068 310.104L246.385 309.521L158.083 261.444Z",
    fill: "#5B6974"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 199,
    width: 105,
    height: 129
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M163.42 199.154L255.316 278.016C227.63 303.966 196.848 320.958 169.129 327.073L151.518 206.717L163.42 199.154Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.767 262.015L157.449 262.598L245.751 310.675L246.068 310.092L157.767 262.015Z",
    fill: "#5A6873"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 199,
    width: 105,
    height: 129
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M162.742 199.183L254.638 278.045C226.952 303.995 196.17 320.987 168.451 327.102L150.84 206.746L162.742 199.183Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.445 262.603L157.128 263.186L245.429 311.262L245.747 310.679L157.445 262.603Z",
    fill: "#596773"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 199,
    width: 104,
    height: 129
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M162.063 199.205L253.959 278.067C226.273 304.017 195.491 321.009 167.772 327.124L150.161 206.768L162.063 199.205Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.134 263.189L156.816 263.772L245.118 311.849L245.435 311.266L157.134 263.189Z",
    fill: "#586672"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 199,
    width: 105,
    height: 129
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M161.385 199.234L253.281 278.097C225.595 304.046 194.813 321.039 167.094 327.153L149.483 206.797L161.385 199.234Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.812 263.777L156.495 264.36L244.796 312.436L245.114 311.854L156.812 263.777Z",
    fill: "#576571"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 199,
    width: 105,
    height: 129
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M160.707 199.264L252.604 278.127C224.917 304.076 194.135 321.069 166.416 327.183L148.806 206.828L160.707 199.264Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.491 264.366L156.174 264.949L244.475 313.026L244.793 312.443L156.491 264.366Z",
    fill: "#576470"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 199,
    width: 104,
    height: 129
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M160.028 199.281L251.924 278.143C224.238 304.093 193.456 321.086 165.737 327.2L148.126 206.844L160.028 199.281Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.185 264.937L155.867 265.519L244.169 313.596L244.486 313.013L156.185 264.937Z",
    fill: "#56636F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 199,
    width: 105,
    height: 129
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M159.349 199.31L251.245 278.172C223.559 304.122 192.777 321.114 165.058 327.229L147.447 206.873L159.349 199.31Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.863 265.524L155.546 266.106L243.848 314.183L244.165 313.6L155.863 265.524Z",
    fill: "#55626E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 199,
    width: 105,
    height: 129
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M158.67 199.332L250.566 278.194C222.88 304.144 192.098 321.137 164.379 327.251L146.768 206.895L158.67 199.332Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.541 266.105L155.224 266.687L243.525 314.764L243.843 314.181L155.541 266.105Z",
    fill: "#54616D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 199,
    width: 104,
    height: 129
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M157.992 199.361L249.888 278.223C222.202 304.173 191.42 321.165 163.701 327.28L146.09 206.924L157.992 199.361Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.22 266.692L154.903 267.275L243.204 315.351L243.521 314.769L155.22 266.692Z",
    fill: "#53606C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 199,
    width: 105,
    height: 129
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M157.313 199.387L249.21 278.249C221.523 304.198 190.741 321.191 163.022 327.306L145.411 206.95L157.313 199.387Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.909 267.282L154.591 267.864L242.893 315.941L243.21 315.358L154.909 267.282Z",
    fill: "#525F6B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 199,
    width: 105,
    height: 129
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M156.635 199.415L248.532 278.277C220.845 304.227 190.063 321.219 162.344 327.334L144.733 206.978L156.635 199.415Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.587 267.868L154.27 268.451L242.571 316.528L242.889 315.945L154.587 267.868Z",
    fill: "#515E6A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 199,
    width: 104,
    height: 129
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M155.956 199.437L247.853 278.3C220.167 304.249 189.384 321.242 161.665 327.356L144.055 207.001L155.956 199.437Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.271 268.44L153.954 269.022L242.255 317.099L242.573 316.516L154.271 268.44Z",
    fill: "#505D69"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 199,
    width: 105,
    height: 129
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M155.277 199.46L247.174 278.322C219.488 304.272 188.705 321.265 160.986 327.379L143.376 207.023L155.277 199.46Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.949 269.02L153.632 269.603L241.933 317.679L242.25 317.097L153.949 269.02Z",
    fill: "#4F5C68"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 199,
    width: 105,
    height: 129
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M154.599 199.488L246.495 278.35C218.809 304.3 188.027 321.292 160.308 327.407L142.697 207.051L154.599 199.488Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.639 269.613L153.321 270.195L241.623 318.272L241.94 317.689L153.639 269.613Z",
    fill: "#4E5B67"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 199,
    width: 104,
    height: 129
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M153.921 199.514L245.817 278.376C218.131 304.326 187.349 321.319 159.63 327.433L142.019 207.077L153.921 199.514Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.317 270.197L153 270.78L241.301 318.856L241.618 318.274L153.317 270.197Z",
    fill: "#4D5A66"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 199,
    width: 105,
    height: 129
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M153.242 199.542L245.139 278.405C217.453 304.354 186.671 321.347 158.951 327.461L141.341 207.106L153.242 199.542Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.995 270.784L152.678 271.367L240.98 319.443L241.297 318.861L152.995 270.784Z",
    fill: "#4C5965"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 199,
    width: 105,
    height: 129
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M152.563 199.565L244.46 278.427C216.774 304.377 185.992 321.37 158.272 327.484L140.662 207.128L152.563 199.565Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.684 271.371L152.366 271.954L240.668 320.03L240.985 319.448L152.684 271.371Z",
    fill: "#4C5865"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 199,
    width: 105,
    height: 129
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M151.884 199.587L243.781 278.449C216.095 304.399 185.313 321.392 157.593 327.506L139.983 207.15L151.884 199.587Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.367 271.941L152.05 272.524L240.351 320.601L240.668 320.018L152.367 271.941Z",
    fill: "#4B5764"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 199,
    width: 105,
    height: 129
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M151.206 199.616L243.102 278.478C215.416 304.428 184.634 321.42 156.915 327.535L139.304 207.179L151.206 199.616Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.046 272.529L151.729 273.111L240.03 321.188L240.348 320.605L152.046 272.529Z",
    fill: "#4A5663"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 199,
    width: 105,
    height: 129
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M150.527 199.641L242.424 278.504C214.738 304.453 183.955 321.446 156.236 327.56L138.626 207.205L150.527 199.641Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.724 273.113L151.407 273.695L239.708 321.772L240.026 321.189L151.724 273.113Z",
    fill: "#495562"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 199,
    width: 105,
    height: 129
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M149.848 199.663L241.745 278.526C214.059 304.475 183.277 321.468 155.557 327.582L137.947 207.227L149.848 199.663Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.413 273.699L151.095 274.281L239.397 322.358L239.714 321.775L151.413 273.699Z",
    fill: "#485461"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 199,
    width: 105,
    height: 129
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M149.171 199.699L241.068 278.562C213.382 304.511 182.6 321.504 154.88 327.618L137.27 207.263L149.171 199.699Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.092 274.293L150.775 274.876L239.076 322.953L239.394 322.37L151.092 274.293Z",
    fill: "#475360"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 199,
    width: 105,
    height: 129
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M148.491 199.714L240.388 278.577C212.702 304.526 181.92 321.519 154.2 327.633L136.59 207.277L148.491 199.714Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.769 274.867L150.452 275.449L238.753 323.526L239.071 322.943L150.769 274.867Z",
    fill: "#46525F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.731 323.514L238.423 324.106L150.361 276.16V275.58L150.444 275.449L238.731 323.514Z",
    fill: "#45515E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.423 324.106L238.103 324.687L150.361 276.918V276.16L238.423 324.106Z",
    fill: "#44505D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.103 324.687L237.783 325.267L150.361 277.676V276.918L238.103 324.687Z",
    fill: "#434F5C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.783 325.267L237.463 325.86L150.361 278.435V277.676L237.783 325.267Z",
    fill: "#424E5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.463 325.86L237.143 326.44L150.361 279.193V278.435L237.463 325.86Z",
    fill: "#424D5A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.143 326.44L236.823 327.021L150.361 279.951V279.193L237.143 326.44Z",
    fill: "#414C59"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.823 327.021L236.515 327.601L150.361 280.709V279.951L236.823 327.021Z",
    fill: "#404B58"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.515 327.601L236.195 328.193L150.361 281.467V280.709L236.515 327.601Z",
    fill: "#3F4A57"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.195 328.194L235.875 328.774L150.361 282.214V281.468L236.195 328.194Z",
    fill: "#3E4957"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.875 328.774L235.555 329.355L150.361 282.972V282.214L235.875 328.774Z",
    fill: "#3D4856"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.555 329.355L235.532 329.402H234.252L150.361 283.73V282.972L235.555 329.355Z",
    fill: "#3C4755"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.866 329.402L150.361 284.489V283.73L234.252 329.402H232.866Z",
    fill: "#3B4654"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.48 329.402L150.361 285.247V284.489L232.866 329.402H231.48Z",
    fill: "#3A4553"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.082 329.402L150.361 286.005V285.247L231.48 329.402H230.082Z",
    fill: "#394452"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.696 329.402L150.361 286.763V286.005L230.082 329.402H228.696Z",
    fill: "#384351"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.31 329.402L150.361 287.522V286.763L228.696 329.402H227.31Z",
    fill: "#384250"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.912 329.402L150.361 288.268V287.522L227.31 329.402H225.912Z",
    fill: "#37414F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.526 329.402L150.361 289.026V288.268L225.912 329.402H224.526Z",
    fill: "#36404E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.139 329.402L150.361 289.784V289.026L224.526 329.402H223.139Z",
    fill: "#353F4D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.741 329.402L150.361 290.543V289.784L223.139 329.402H221.741Z",
    fill: "#343E4C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.355 329.402L150.361 291.301V290.542L221.741 329.402H220.355Z",
    fill: "#333D4B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.969 329.402L150.361 292.059V291.301L220.355 329.402H218.969Z",
    fill: "#323C4A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.571 329.402L150.361 292.818V292.059L218.969 329.402H217.571Z",
    fill: "#313B49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.185 329.402L150.361 293.576V292.817L217.571 329.402H216.185Z",
    fill: "#303A48"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask195_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask195_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.799 329.402L150.361 294.334V293.575L216.185 329.402H214.799Z",
    fill: "#2F3948"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask196_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask196_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.401 329.402L150.361 295.08V294.334L214.799 329.402H213.401Z",
    fill: "#2E3847"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask197_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask197_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.015 329.402L150.361 295.839V295.08L213.401 329.402H212.015Z",
    fill: "#2E3746"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask198_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask198_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.629 329.402L150.361 296.597V295.838L212.015 329.402H210.629Z",
    fill: "#2D3645"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask199_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask199_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.231 329.402L150.361 297.355V296.597L210.629 329.402H209.231Z",
    fill: "#2C3544"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask200_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask200_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.844 329.402L150.361 298.113V297.355L209.231 329.402H207.844Z",
    fill: "#2B3443"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask201_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask201_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.458 329.402L150.361 298.871V298.113L207.844 329.402H206.458Z",
    fill: "#2A3342"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask202_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask202_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.06 329.402L150.361 299.63V298.871L206.458 329.402H205.06Z",
    fill: "#293241"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask203_911_37915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 204,
    width: 110,
    height: 126
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 210.988L234.667 329.402C198.639 317.495 168.997 298.587 150.373 277.167L247.652 204.152L259.985 210.988Z",
    fill: "white"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask203_911_37915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.361 299.63L205.06 329.402H150.361V299.63Z",
    fill: "#293241"
  }))), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M144.094 280.449L133.372 304.013L134.356 305.34L146.239 282.984L144.094 280.449Z",
    fill: "#98C0D9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M288.715 322.104C285.35 312.093 321.556 310.47 321.556 310.47L327.586 289.476L355.806 287.415L363.578 267.736L397.106 271.563L408.717 292.462L378.577 294.594L369.383 314.711L335.938 308.456L329.458 328.312C329.481 328.324 291.25 329.651 288.715 322.104Z",
    fill: "#343643"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M258.876 197.04C259.604 196.639 259.868 195.724 259.467 194.996C259.065 194.268 258.15 194.004 257.422 194.405C256.695 194.807 256.43 195.722 256.832 196.45C257.233 197.177 258.149 197.442 258.876 197.04Z",
    fill: "#373879"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M270.789 173.36L257.152 196.96L247.994 203.654L259.889 210.845L262.756 200.585L276.44 176.618C277.328 175.066 276.795 173.087 275.243 172.187C273.691 171.275 271.689 171.808 270.789 173.36Z",
    fill: "#03090F"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M259.986 210.994C260.782 209.557 258.666 206.863 255.26 204.977C251.855 203.091 248.449 202.727 247.653 204.163C246.857 205.6 248.973 208.294 252.379 210.18C255.785 212.066 259.19 212.431 259.986 210.994Z",
    fill: "#DFFBFC"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M398.895 259.538C398.895 259.538 409.273 261.801 410.019 263.507C410.778 265.213 402.958 291.644 401.726 292.438C400.494 293.232 394.061 267.701 394.061 267.701L398.895 259.538Z",
    fill: "#03090F"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M276.452 173.301L270.043 180.114L275.398 184.9L283.691 177.081L276.452 173.301Z",
    fill: "#3D5B81"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M315.442 304.961C315.442 304.961 317.764 315.327 316.52 316.725C315.288 318.135 288.015 322.163 286.783 321.381C285.551 320.599 305.999 304.013 305.999 304.013L315.442 304.961Z",
    fill: "#03090F"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M308.428 100.938L297.398 146.076L273.692 173.514C272.685 174.687 272.791 176.441 273.929 177.483L278.087 181.251C279.142 182.21 280.741 182.234 281.831 181.322L308.736 158.682L325.82 117.974L308.428 100.938Z",
    fill: "#4D8D8D"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M326.152 144.098C326.152 144.098 292.316 211.912 292.197 224.506C292.079 237.111 297.754 305.34 297.754 305.34H319.221C319.221 305.34 318.38 237.36 321.567 228.498C324.754 219.648 360.995 138.387 360.995 138.387L326.152 144.098Z",
    fill: "#DFFBFC"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M319.411 305.53H297.576L297.564 305.352C297.505 304.665 291.889 236.969 292.008 224.494C292.126 211.995 324.6 146.775 325.974 144.003L326.021 143.92L326.116 143.908L361.303 138.15L361.161 138.47C360.793 139.288 324.884 219.826 321.745 228.569C318.605 237.289 319.411 304.665 319.411 305.34V305.53ZM297.931 305.151H319.032C318.972 300.388 318.285 237.076 321.389 228.439C324.434 219.968 358.175 144.24 360.675 138.636L326.282 144.264C324.896 147.06 292.517 212.291 292.399 224.506C292.268 236.649 297.612 301.3 297.931 305.151Z",
    fill: "#293241"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 143.399C331.673 143.399 326.377 222.741 326.744 230.429C327.123 238.107 393.694 271.552 393.694 271.552L400.435 257.702L351.6 222.598L366.303 177.863C369.608 167.816 369.217 156.905 365.201 147.119L361.291 137.57L331.673 143.399Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M393.789 271.812L393.611 271.729C390.886 270.366 326.934 238.142 326.555 230.441C326.188 222.835 331.424 144.192 331.483 143.398L331.495 143.256L331.637 143.232L361.422 137.392L365.39 147.083C369.419 156.904 369.81 167.875 366.492 177.957L351.837 222.55L400.684 257.666L393.789 271.812ZM331.862 143.552C331.602 147.391 326.59 222.989 326.946 230.405C327.301 237.703 389.855 269.383 393.623 271.279L400.21 257.749L351.399 222.657L351.446 222.527L366.137 177.815C369.419 167.816 369.039 156.94 365.047 147.201L361.197 137.806L331.862 143.552Z",
    fill: "#293241"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M308.44 100.795L319.802 143.055C321.2 148.268 321.851 149.334 327.384 148.031L360.083 143.647C366.042 142.249 369.276 136.278 367.013 130.899L345.972 81.0103L322.467 82.9295L308.44 100.795Z",
    fill: "#76CCCC"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M305.147 72.7054C304.222 61.178 318.925 61.095 319.79 67.6822C320.797 75.3119 320.015 76.8757 328.142 83.4273C328.142 83.4273 325.003 88.0833 320.536 90.6897L316.342 83.0008C311.118 85.5361 306.509 89.659 305.147 72.7054Z",
    fill: "#EE6B4D"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M325.607 81.271L322.017 87.3961L317.93 86.2232L317.551 90.0025L321.034 93.4145L322.775 89.3509L327.349 91.365L329.481 81.6501L325.607 81.271Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M270.043 180.114C270.043 180.114 257.899 182.614 258.053 188.075C258.207 193.537 263.219 195.503 267.745 193.418C272.27 191.333 275.398 184.9 275.398 184.9L270.043 180.114Z",
    fill: "#EE6B4D"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M305.218 70.4185C296.38 71.9942 299.354 62.5163 303.299 61.1776C308.44 59.436 306.77 63.9973 316.627 60.9643C317.883 60.5734 318.286 64.874 318.286 64.874C323.51 63.2509 320.892 69.5418 322.74 78.3207L314.589 70.6318L314.246 74.9087L312.315 75.5603C312.315 75.5721 313.772 68.9021 305.218 70.4185Z",
    fill: "#525460"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M314.968 71.3781C315.027 67.1605 321.591 70.0986 317.551 76.1763L314.968 71.3781Z",
    fill: "#EE6B4D"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M341.648 95.5229C339.374 109.159 361.777 118.483 361.777 118.483L349.906 137.593L350.439 140.128L367.002 130.899L352.086 95.5229H341.648Z",
    fill: "#4D8D8D"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M322.775 89.3511L321.567 92.1707L324.327 96.0093C324.327 96.0093 322.858 128.518 348.283 139.773L357.204 138.399L351.707 129.679C351.707 129.679 331.566 124.526 325.832 95.8434L325.808 90.678L322.775 89.3511Z",
    fill: "#293241"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M345.676 80.8916C345.676 80.8916 381.858 106.292 383.304 114.716C384.725 122.985 362.535 136.539 361.73 137.036C361.718 137.048 361.694 137.036 361.694 137.024L357.619 130.935C356.896 129.857 357.062 128.423 357.998 127.535L369.312 116.742C369.312 116.742 360.379 112.252 347.963 106.067C335.535 99.8711 345.676 80.8916 345.676 80.8916Z",
    fill: "#76CCCC"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M357.607 130.935L353.531 134.406L357.63 140.117L361.777 136.563L357.607 130.935Z",
    fill: "#98C0D9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M353.531 134.406C353.531 134.406 344.302 137.972 343.117 140.555C341.921 143.126 337.94 150.578 338.71 151.206C341.66 153.599 345.925 145.969 345.925 145.969C345.925 145.969 344.812 151.893 344.835 153.066C344.859 154.239 350.155 142.581 350.155 142.581C350.155 142.581 353.436 143.493 356.848 139.204L353.531 134.406Z",
    fill: "#EE6B4D"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M433.75 51.2258H589.223C589.223 51.2258 581.404 37.9686 565.753 44.6031C565.753 44.6031 557.105 17.2239 539.428 16.2405C521.752 15.2572 522.356 38.7268 522.356 38.7268C522.356 38.7268 515.651 15.2928 481.578 15.2691C462.101 15.2454 456.236 40.2433 456.236 40.2433C456.236 40.2433 433.75 36.8313 433.75 51.2258Z",
    fill: "#525460"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M275.292 30.5284H387.557C387.557 30.5284 374.193 16.0747 364.881 26.6188C364.881 26.6188 368.329 8.04216 349.231 1.19438C330.133 -5.65339 327.207 19.1787 327.207 19.1787C327.207 19.1787 318.913 -2.71524 305.952 1.19438C292.991 5.10401 293.927 23.6807 293.927 23.6807C293.927 23.6807 282.056 17.8162 275.292 30.5284Z",
    fill: "#525460"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M132.708 112.086H242.77C242.77 112.086 241.609 96.222 223.08 104.148C223.08 104.148 234.383 78.1904 206.056 71.698C177.728 65.2056 180.276 95.7718 180.276 95.7718C180.276 95.7718 175.951 85.2751 159.839 86.8745C143.738 88.4739 152.363 106.47 152.363 106.47C152.363 106.47 132.708 101.992 132.708 112.086Z",
    fill: "#525460"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundBackground);
export default __webpack_public_path__ + "static/media/NotFoundBackground.bb3db2a347ec1d7f60dfc4da65e4a718.svg";
export { ForwardRef as ReactComponent };